function getCookie(name: string): string | null {
  try {
    if (typeof document === 'undefined') return null;
    const m = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]+)`));
    return m ? decodeURIComponent(m[1]) : null;
  } catch {
    return null;
  }
}

export function getReferralCode(): string | null {
  try {
    if (typeof window !== 'undefined') {
      const ref = new URLSearchParams(window.location.search).get('ref');
      if (ref) return ref;
    }
  } catch {}
  return getCookie('fh_ref_code');
}

export function setReferralCookie(code: string, maxAgeSeconds = 60 * 60 * 24 * 180) {
  try {
    if (typeof document === 'undefined') return;
    if (!code) return;
    document.cookie = [
      `fh_ref_code=${encodeURIComponent(code)}`,
      'Path=/',
      `Max-Age=${maxAgeSeconds}`,
      'SameSite=Lax'
    ].join('; ');
  } catch {}
}

